import {
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
} from "react";
import Notification from "@blacknut/javascript-sdk/dist/model/Notification";
import Notifications from "./Notifications";
import React from "react";
export interface NotificationSubscription {
  remove: () => void;
}

interface TNotificationContext {
  notifications: Notification[];
  push: (notification: Notification) => NotificationSubscription;
}
const defaultValue: TNotificationContext = {
  notifications: [],
  push: (_notification: Notification): NotificationSubscription => {
    console.log("NOP");
    return {
      remove: () => {
        console.log("NOP");
      },
    };
  },
};

export const NotificationContext =
  createContext<TNotificationContext>(defaultValue);

export const NotificationContextProvider = (
  props: PropsWithChildren<{
    renderNotifications?: (notifications: Notification[]) => JSX.Element;
    maxTime?: number;
  }>
) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const cssVar = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue("--toaster-max-time");
  const _maxTime =
    props.maxTime ||
    (cssVar && parseInt(cssVar, 10)) ||
    (process.env.NODE_ENV === "test" ? 500 : 2000);

  const notificationsRef = useRef(notifications);

  const push = useCallback(
    (notification: Notification) => {
      const timer = setTimeout(() => {
        const newOnes = notificationsRef.current.filter(
          (n) => n !== notification
        );
        setNotifications(newOnes);
        notificationsRef.current = newOnes;
      }, _maxTime * 2);

      const newOnes = [...notificationsRef.current, notification];
      setNotifications(newOnes);
      notificationsRef.current = newOnes;
      return {
        remove: () => {
          const newOnes = notificationsRef.current.filter(
            (n) => n !== notification
          );
          clearTimeout(timer);
          setNotifications(newOnes);
          notificationsRef.current = newOnes;
        },
      };
    },
    [_maxTime, setNotifications]
  );
  return (
    <NotificationContext.Provider
      value={{
        notifications,
        push,
      }}
    >
      {props.children}

      {props.renderNotifications && props.renderNotifications(notifications)}
      {!props.renderNotifications && (
        <Notifications notifications={notifications} />
      )}
    </NotificationContext.Provider>
  );
};

const useNotifications = () => {
  return useContext(NotificationContext);
};

export { useNotifications };
